import ListTemplate from "components/ListTemplate";
import React from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { mapResponseToFilterValues, mapFilterValuesToInstruction } from "./helpers";
import Filters from "./Filters";
import Tag from "components/Tag/Tag";
import TagList from "components/Tag/TagList";
import FavoriteIcon from "../../components/Atoms/FavoriteIcon";
import { useLoaderData } from "react-router";

const NameElement = ({ item }: { item: server.dto.ArtistForList }) => {
  return <div className="flex-column gap-small">
    <div><a href={routes.company_Detail(item.artistId).absolute} className="table-main-link">{item.name}</a></div>
    {!item.displayInFilters && <div><Tag color="red-basic" label={RESX.Artist.NoLongerActive} /></div>}
  </div>;
};

const ArtistListApp = () => {
  const viewModel = useLoaderData<server.viewmodel.ArtistListFrontModel>();

  return <ListTemplate
    title={site.currentEnvironment.functionGroups.artist.plural}
    filterSet="company_Artist_List"
    defaultFilters={viewModel.defaultFilters}
    initialInstruction={viewModel.initialInstruction}
    fetchFunction={window.CoreApi.Artist.Paginated}
    getId={item => item.artistId}
    layout={{
      type: "table",
      columns: [{
        key: "favorite",
        header: "",
        render: item => <FavoriteIcon artistId={item.artistId} isFavorite={item.isFavorite} />,
        size: "fit-content(38px)"
      }, {
        key: "name",
        header: RESX.GeneralLabels.Name,
        render: item => <NameElement item={item} />,
        size: "1fr"
      }, {
        key: "tags",
        header: "",
        render: item => <TagList tags={item.tags} length="short" />,
        size: "fit-content(400px)"
      }]
    }}
    filters={<Filters initialTags={viewModel.tags} />}
    functions={{
      mapFilterValuesToInstruction,
      mapResponseToFilterValues
    }}
  />;
};

export default ArtistListApp;
